export const PipelineEnum = {
    "ProjectNLMPrediction": 1
   }